import { C, Canvas, Caption, Heading, PageSheet, Pill } from "./MockupParts";

const P = (n) => `/mockups/pages/${n}.png`;

const TAG_TL = new Set(["thc-area", "thc-bars", "tr-risk"]);

const LAYOUT = {
  wide: {
    w: 1200, h: 627, head: { x: 64, y: 150, w: 370, size: 40 },
    sheets: [
      { n: "thc-bars", x: 480, y: 170, w: 228, rot: -8 },
      { n: "thc-area", x: 560, y: 140, w: 240, rot: -2 },
      { n: "thc-cover", x: 650, y: 110, w: 262, rot: 4 },
      { n: "tr-risk", x: 920, y: 190, w: 196, rot: -4 },
      { n: "tr-cover", x: 975, y: 160, w: 200, rot: 5 },
    ],
    pill: { x: 945, y: 104 },
    caps: [{ x: 540, y: 540, w: 320, t: "Informe PDF personalizado · 20 páginas" },
      { x: 915, y: 540, w: 260, t: "Team Readiness Report · 6 páginas", align: "center" }],
  },
  square: {
    w: 1080, h: 1080, head: { x: 72, y: 40, w: 900, size: 50 },
    sheets: [
      { n: "thc-bars", x: 70, y: 440, w: 262, rot: -8 },
      { n: "thc-area", x: 175, y: 405, w: 275, rot: -2 },
      { n: "thc-cover", x: 290, y: 370, w: 300, rot: 4 },
      { n: "tr-risk", x: 640, y: 445, w: 236, rot: -4 },
      { n: "tr-cover", x: 750, y: 410, w: 250, rot: 5 },
    ],
    pill: { x: 705, y: 360 },
    caps: [{ x: 150, y: 880, w: 400, t: "Informe PDF personalizado · 20 páginas", align: "center" },
      { x: 660, y: 880, w: 340, t: "Team Readiness Report · 6 páginas", align: "center" }],
  },
};

export const MockupThc = ({ format, innerRef }) => {
  const L = LAYOUT[format];
  return (
    <Canvas w={L.w} h={L.h} innerRef={innerRef}>
      <div className="absolute" style={{ left: L.head.x, top: L.head.y, width: L.head.w }}>
        <Heading
          size={L.head.size}
          title="Diagnóstico rápido"
          subtitle="30 preguntas · 6 áreas de gestión de talento · informe PDF personalizado"
          price="47 €"
        />
      </div>
      {L.sheets.map((s, i) => (
        <PageSheet key={s.n} src={P(s.n)} w={s.w} x={s.x} y={s.y} rot={s.rot} z={i + 1} tag={TAG_TL.has(s.n) ? "tl" : "br"} />
      ))}
      <div className="absolute" style={{ left: L.pill.x, top: L.pill.y, zIndex: 10 }}>
        <Pill gold>Documento para inversores</Pill>
      </div>
      {L.caps.map((c) => (
        <Caption key={c.t} x={c.x} y={c.y} w={c.w} align={c.align} color={c.t.startsWith("Team") ? "#6B5316" : C.forest}>
          {c.t}
        </Caption>
      ))}
    </Canvas>
  );
};
